/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { t } from 'utils/translates';
import UserFlowFundsHistoryTable from '../../../../../../components/UserFlowFunds/UserFlowFundsHistoryTable';

class MyBalanceHistory extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="panel panel-default panel-heading_padding-large">
          <div className="panel-heading">
            <h1 className="panel-title text-center">
              <i className="fa fa-book" /> {t('История')}
            </h1>
          </div>
          <div className="panel-body">
            <UserFlowFundsHistoryTable {...this.props} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(MyBalanceHistory);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/MyBalance/MyBalanceHistory/MyBalanceHistory.js